import React, { useState } from 'react'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import { isEmpty } from 'lodash'
import { withTheme } from 'theming'
import CustomImage from '../../customImage/customImage'
import Logo from '../../../assets/LUMICKO_Header_Logo.gif'

const AtomicFooter = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  theme,
}) => {
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const {
    customNavigate,
    getTemplateImage,
    FBDefaultLogo,
    ThreadsIcon,
    InstaDefaultLogo,
    TGDefaultLogo,
    YTDefaultLogo,
    TwitterDefaultLogo,
    BitchuteDefaultLogo,
    RumbleDefaultLogo,
    BoxcastDefaultLogo,
    TikTokDefaultLogo,
    RednoteIcon,
    getExternalLink,
    AndroidStore,
    AppleStore,
    AndroidTv,
    AppleTv,
    RokuTv,
    FireTv,
    SamsungTv,
    LGTv,
  } = useTemplateHook()

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const socialIcons = {
    facebook: FBDefaultLogo,
    twitter: TwitterDefaultLogo,
    instagram: InstaDefaultLogo,
    telegram: TGDefaultLogo,
    youtube: YTDefaultLogo,
    bitchute: BitchuteDefaultLogo,
    tiktok: TikTokDefaultLogo,
    rumble: RumbleDefaultLogo,
    boxcast: BoxcastDefaultLogo,
    rednote: RednoteIcon,
    threads: ThreadsIcon,
  }
  const appIcons = {
    android: AndroidStore,
    apple: AppleStore,
  }
  const tvIcons = {
    android: {
      icon: AndroidTv,
      aspectRatio: '107/18',
      height: '18px',
    },
    apple: {
      icon: AppleTv,
      aspectRatio: '41/20',
      height: '20px',
    },
    roku: {
      icon: RokuTv,
      aspectRatio: '68/21',
      height: '21px',
    },
    amazon: {
      icon: FireTv,
      aspectRatio: '73/21',
      height: '21px',
    },
    samsung: {
      icon: SamsungTv,
      aspectRatio: '67/26',
      height: '26px',
    },
    lg: {
      icon: LGTv,
      aspectRatio: '85/17',
      height: '17px',
    },
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const getSocialIcons = (key) => {
    return <img className="w-full" src={socialIcons[key]} alt={`${key}`} />
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <footer
      className={`${isEdit && hoverState && 'component-hover-class'}`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', '#000000'),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onEdit={() => handleModal()}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}
      <div className="relative lg:px-[6.6%] py-9">
        <div className="flex flex-col-reverse lg:flex-col items-center">
          <div className="w-full flex flex-col lg:flex-row lg:justify-between items-center">
            <div className="flex flex-col lg:flex-row  items-center mb-6 lg:mb-0">
              <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start">
                {[...data?.app_link].map((item, index) => (
                  <div
                    style={{ height: '34px' }}
                    className="lg:ml-8 first:ml-0 mt-6 lg:mt-0 inline-block"
                    key={index}
                  >
                    <a href={getExternalLink(item.url)} target="_blank" rel="noreferrer">
                      <img className="h-full" src={appIcons[item.name]} alt={`${item.name}`} />
                    </a>
                  </div>
                ))}
              </div>

              <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start">
                {[...data?.tv_link].map((item, index) => (
                  <div
                    className={`justify-center lg:justify-start ${
                      isEmpty(data?.app_link) ? 'first:ml-0 ' : 'lg:ml-8 '
                    } lg:ml-8 flex mt-6 lg:mt-0 `}
                    key={index}
                  >
                    <a href={getExternalLink(item.url)} target="_blank" rel="noreferrer">
                      <img
                        style={{
                          height: tvIcons[item.name].height,
                          aspectRatio: tvIcons[item.name].aspectRatio,
                        }}
                        className=""
                        src={tvIcons[item.name].icon}
                        alt={`${item.name}`}
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className={`flex flex-col items-center lg:items-start text-center  `}>
              <div className="flex items-center">
                {[...data?.social_handles].map((item, index) => (
                  <div className=" md:w-6 w-4 first:ml-0 ml-[20px] inline-block" key={index}>
                    <a
                      href={item.url ? getExternalLink(item.url) : '#'}
                      target={item.url ? '_blank' : '_self'}
                      rel="noreferrer"
                    >
                      {getSocialIcons(item.name)}
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className=" w-full justify-center flex mt-8 lg:hidden">
              <p
                className={` text-xs  ${getStyleValue('copyright', 'font_format', '')} mb-0`}
                style={{
                  fontFamily: getStyleValue('copyright', 'font', ''),
                  color: getStyleValue('copyright', 'color', '#fff'),
                }}
              >
                {data?.copyright_text}
              </p>
            </div>
          </div>

          <div className="mb-6 lg:mb-0 lg:mt-8 w-full flex flex-col-reverse lg:flex-row lg:justify-between items-center">
            <div className="w-full lg:w-auto flex flex-col lg:flex-row justify-center lg:justify-start items-center">
              {!isEmpty(data.sitemap)
                ? [...data.sitemap].map((info, index) => {
                    return (
                      <p
                        style={{
                          color: getStyleValue('sitemap_header', 'color', '#fff'),
                          fontFamily: getStyleValue('sitemap_header', 'font', ''),
                        }}
                        className={`${getStyleValue(
                          'sitemap_header',
                          'font_format',
                          '',
                        )} text-xs lg:text-sm 2xl:text-base lg:ml-8 first:ml-0 lg:mt-0 mt-4 mb-0 cursor-pointer`}
                        onClick={() => handleRedirect(info.link)}
                        key={index}
                      >
                        {info?.text}
                      </p>
                    )
                  })
                : null}
            </div>

            <div
              className="flex justify-center mb-6 lg:mb-0"
              onClick={() => customNavigate('DIRECT', '/home', isEdit)}
            >
              <CustomImage
                imageUrl={Logo}
                imgClass="cursor-pointer"
                imgStyle={{
                  backgroundColor: 'transparent',
                  width: 'max(8.333vw,140px)',
                  // aspectRatio: '160/70',
                }}
                loaderClass=" cursor-pointer"
                loaderStyle={{
                  background: '#5A5A5A50',
                  width: 'max(8.333vw,140px)',
                  // aspectRatio: '160/70',
                }}
                imgAlt={'Logo'}
              />
            </div>
          </div>

          <div className="w-full justify-start hidden lg:flex">
            <p
              className={` text-xs ${getStyleValue('copyright', 'font_format', '')} mb-0`}
              style={{
                fontFamily: getStyleValue('copyright', 'font', ''),
                color: getStyleValue('copyright', 'color', '#fff'),
              }}
            >
              {data?.copyright_text}
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default withTheme(AtomicFooter)
